import { updateBreadcrumbTitle } from './utilities/updateBreadcrumbTitle';

(({ currentPageTitle } = {}) => {
  updateBreadcrumbTitle(currentPageTitle);
})(window.drupalSettings);
